import React from "react";
import { ComingSoonImg, MyAttendenceAveargeIcon } from "../../assets/images";
import BoxLoader from "../commons/BoxLoader/BoxLoader";
import { useLocation } from "react-router-dom";
type AppProps = {
  attendanceAverage: number;
  fetching: boolean;
};

const AttendanceDetails = ({ attendanceAverage, fetching }: AppProps) => {
  const { pathname } = useLocation();
  return (
    <div
      className={`boxs w-100 ${pathname.includes("hrms") ? "p-3" : "pr-2 pl-2 pt-3 pb-3"}`}
      style={{ height: pathname.includes("hrms") ? "150px" : "125px" }}
    >
      {fetching ? (
        <BoxLoader style={{ height: "100%" }} />
      ) : (
        <>
          <div className="d-flex w-100" style={{gap:"14px", marginTop:"10px"}}>
          <img src={MyAttendenceAveargeIcon} alt="Attendance Icon" style={{width:'69px'}}/>
<div>
            <span
              className={
                pathname.includes("hrms") ? "mb-3" : `boxs-container-heading`
              }
              style={{
                fontWeight: 600,
                fontSize: pathname.includes("hrms") ? "16px" : "14px",
              }}
            >
              {pathname.includes("hrms")
                ? "Avg. Attendance Rate"
                : "My Attendance Average"}
            </span>

            <div className="w-100">
            <div className="d-flex flex-column">
              <div
                style={{
                  fontSize: pathname.includes("hrms") ? "30px" : "35px",
                  fontWeight: 500,
                }}
              >
                {attendanceAverage?.toFixed(2)}
              </div>
              
            </div>
          </div>
            </div>
          </div>
          
        </>
      )}
    </div>
  );
};

export default AttendanceDetails;
